<template>
    <main>
        <Navbar />
        <div class="main">
            <div class="container">
                <form @submit.prevent="addEvent">
                    <div class="form-group">
                        <label class="text-white" for="liga">Liga</label>
                        <input type="text" class="form-control" id="liga" v-model="liga" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="liga-id">ID da liga</label>
                        <input type="text" class="form-control" id="liga-id" v-model="liga_id" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="time-casa">Time da casa</label>
                        <input type="text" class="form-control" id="time-casa" v-model="time_casa" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="time-fora">Time de fora</label>
                        <input type="text" class="form-control" id="time-fora" v-model="time_fora" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="form-group">
                        <label class="text-white" for="horario">Horário</label>
                        <input type="datetime-local" class="form-control" id="horario" v-model="horario" :readonly="block" autocomplete="off" spellcheck="false" required>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label class="text-white" for="odd-casa">Casa</label>
                                <input type="number" class="form-control" step='0.01' id="odd-casa" v-model="odd_casa" :readonly="block" autocomplete="off" spellcheck="false" required>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label class="text-white text-center w-100" for="odd-empate">Empate</label>
                                <input type="number" class="form-control" step='0.01' id="odd-empate" v-model="odd_empate" :readonly="block" autocomplete="off" spellcheck="false" required>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label class="text-white" for="odd-fora">Fora</label>
                                <input type="number" class="form-control" step='0.01' id="odd-fora" v-model="odd_fora" :readonly="block" autocomplete="off" spellcheck="false" required>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label class="text-white" for="odd-ambas">Ambas</label>
                                <input type="number" class="form-control" step='0.01' id="odd-ambas" v-model="odd_ambas" :readonly="block" autocomplete="off" spellcheck="false" required>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label class="text-white" for="odd-nao_ambas">Não ambas</label>
                                <input type="number" class="form-control" step='0.01' id="odd-nao_ambas" v-model="odd_nao_ambas" :readonly="block" autocomplete="off" spellcheck="false" required>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <button type="submit" class="btn btn-block btn-success" :disabled="block">
                                <i class="fas fa-save mr-2"></i>Salvar
                            </button>
                        </div>
                        <div class="col">
                            <a class="btn btn-block btn-danger" @click="cancel" :class="{'disabled': block}">
                                <i class="fas fa-ban mr-2"></i>Cancelar
                            </a>
                        </div>
                    </div>
                </form>
            </div>            
        </div>
      <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    </main>
</template>

<script>
import {api} from '../api'
import md5 from 'md5';
import Navbar from './Navbar'
import Swal from 'sweetalert2'
import moment from 'moment-timezone'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
    data() {
        return {
            liga: '',
            liga_id: '',
            time_casa: '',
            time_fora: '',
            odd_casa: '',
            odd_empate: '',
            odd_fora: '',
            odd_ambas: '1.00',
            odd_nao_ambas: '1.00',
            horario: '',
            block: true,
            loading: false,
            network_erros: {
				0: {
					message: 'Não há conexão com a internet!'
                },
                401: {
                    message: 'Você não tem autorização para realizar essa operação!'
                },
				404: {
					message: 'Página solicitada não foi encontrada!'
				},
				500: {
					message: 'O servidor está passando por problemas técnicos!'
				},
				408: {
					message: 'Por favor, verifique sua conexão de rede e tente novamente!'
				}					
			}
        }
    },
    components: {
        Navbar,
        Loading
    },
    methods: {
        addEvent() {

            const self = this;

            if (self.liga.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe a liga!',
                    'warning'
                )
            } else if (self.liga_id.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o ID da liga!',
                    'warning'
                )
            } else if (self.time_casa.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o time da casa!',
                    'warning'
                )
            } else if (self.time_fora.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o time de fora!',
                    'warning'
                )
            } else if (self.horario.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe o horário!',
                    'warning'
                )
            } else if (self.odd_casa.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe a cotação da casa!',
                    'warning'
                )
            } else if (self.odd_empate.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe a cotação empate!',
                    'warning'
                )
            } else if (self.odd_fora.toString().trim() == '') {
                Swal.fire(
                    'Atenção!',
                    'Informe a cotação de fora!',
                    'warning'
                )
            } else {

                self.loading = true;

                let horario_partida = moment(self.horario).format();
                let hash = md5(data_partida + self.liga_id + 1 + 2);
                let hash_team_home = md5(data_partida + self.liga_id + 1);
                let hash_team_away = md5(data_partida + self.liga_id + 2);
                let hash_reverse = md5(data_partida + self.liga_id + 2 + 1);
                let hora_partida = moment(self.horario).format('HH:mm');
                let data_partida = moment(self.horario).tz('America/Recife').format('YYYY-MM-DD');
                let data_original = moment(self.horario).tz('Europe/London').format('YYYY-MM-DD');
                let ultima_atualizacao = moment().tz('America/Recife').format();
                
                let evento = {
                    api_id: self.generateId(),
                    ativo: 1,
                    status: 0,
                    servidor: 'betsnow',
                    bloqueado: 2,
                    automatico: 1,
                    liga: self.liga,
                    esporte: '1',
                    liga_id: self.liga_id,
                    ao_vivo: 2,
                    pre_jogo: 1,
                    time_casa: self.time_casa,
                    time_fora: self.time_fora,
                    time_casa_id: 1,
                    time_fora_id: 2,
                    hora: hora_partida,
                    data: data_partida,
                    data_original: data_original,
                    horario: horario_partida,
                    ultima_atualizacao: ultima_atualizacao,
                    placar_casa_90: 0,
                    placar_fora_90: 0,
                    placar_casa_pt: 0,
                    placar_fora_pt: 0,
                    placar_casa_st: 0,
                    placar_fora_st: 0,
                    estatisticas: [],
                    odds: [{
                        id: 1,
                        cat_id: 90,
                        cat_name: 'Principais',
                        option: 'Casa',
                        odd: self.odd_casa
                    },{
                        id: 2,
                        cat_id: 90,
                        cat_name: 'Principais',
                        option: 'Empate',
                        odd: self.odd_empate
                    },{
                        id: 3,
                        cat_id: 90,
                        cat_name: 'Principais',
                        option: 'Fora',
                        odd: self.odd_fora
                    },{
                        id: 11,
                        cat_id: 90,
                        cat_name: 'Ambas equipes marcam',
                        option: 'Sim',
                        odd: self.odd_ambas
                    },{
                        id: 12,
                        cat_id: 90,
                        cat_name: 'Ambas equipes marcam',
                        option: 'Não',
                        odd: self.odd_nao_ambas
                    }],
                    hash: hash,
                    hash_reverse: hash_reverse,
                    hash_team_home: hash_team_home,
                    hash_team_away: hash_team_away                    
                };

                api.post('evento', {
                    evento: evento
                }).then((response) => {
                    switch(response.data.result) {
                        case 'success':
                            self.time_casa = '';
                            self.time_fora = '';
                            self.horario = '';
                            self.odd_casa = '';
                            self.odd_empate = '';
                            self.odd_fora = '';
                            self.odd_ambas = '1.00';
                            self.odd_nao_ambas = '1.00';
                            Swal.fire(
                                'Parabéns!',
                                'O evento foi publicado com sucesso!',
                                'success'
                            );
                        break;
                        default: 
                            Swal.fire(
                                'Atenção',
                                response.data.message
                            );
                        break;
                    }
                }).catch((error) => {
                    try {
                        Swal.fire(
                            'Falha',
                            self.network_erros[error.status]['message'],
                            'warning'
                        );
                    } catch(e) {
                        Swal.fire(
                            'Falha',
                            self.network_erros[408]['message'],
                            'warning'
                        );
                    }
                }).finally(() => {
                    self.loading = false;
                });
            }
        },
        cancel() {
            this.liga = '';
            this.liga_id = '';
            this.time_casa = '';
            this.time_fora = '';
            this.odd_casa = '';
            this.odd_empate = '';
            this.odd_fora = '';
            this.horario = '';
        },
        generateId() {
            return parseInt((new Date().getTime().toString().slice(-8)));
        }
    },
    watch: {
        liga(value) {
            this.liga = value.replace(/[^a-zà-ú0-9-\s]+/gi,'');
        },
        liga_id(value) {
            this.liga_id = value.replace(/[^a-zA-Z0-9-]+/gi,'');
        },
        time_casa(value) {
            this.time_casa = value.replace(/[^a-zà-ú0-9\s]+/gi,'');
        },
        time_fora(value) {
            this.time_fora = value.replace(/[^a-zà-ú0-9\s]+/gi,'');
        }
    },
    beforeMount() {
        try {

            const {pipe} = JSON.parse(localStorage.getItem('auth'));

            this.block = pipe == 1 ? false : true;
        } catch(e) {
            this.block = false;
        }
    },
}
</script>